// @flow

import React from 'react';
import type { Props } from '.';
import './sysdown.scss';

export default class SystemDownModal extends React.Component<Props> {
  props: Props;

  refresh() {
    window.location = '/';
  }

  renderMessageContent() {
    const { sysdownmessage } = this.props;
    return (
      <section className="generic_modal splash-page system-down">
        <div className="system-down-splash-prs-logo" />
        <h1>Sorry</h1>
        <p>
          {sysdownmessage.title}
        </p>
        <p>
          {sysdownmessage.message}
        </p>
        <div className="modal-buttons">
          <button className="btn-prs dark-btn blue-bg btn-block" type="button" onClick={this.refresh}>Refresh</button>
        </div>
      </section>
    );
  }

  render() {
    const { sysdownmessage } = this.props;
    if (sysdownmessage && sysdownmessage.msgId) {
      return this.renderMessageContent();
    }
    return null;
  }
}
